module.exports = __webpack_public_path__ + "img/GT.9672c9c0.svg";